var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-region.1868add5.png","uri@2x": __webpack_public_path__ + "icon-region.6c383838.png","uri@3x": __webpack_public_path__ + "icon-region.df6b1130.png",
    width: 20,
    height: 20
});